import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";

// This snippet was provided by Hotjar
const startHotjar = (hjid: number, hjsv: number) => {
  (function (h: any, o: any, t: any, j: any, a?: any, r?: any) {
    h.hj =
      h.hj ||
      function () {
        // eslint-disable-next-line prefer-rest-params
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid, hjsv };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(
    getWindowOrThrow(),
    getWindowOrThrow().document,
    "https://static.hotjar.com/c/hotjar-",
    ".js?sv="
  );
};

export default startHotjar;
